import { ThemeCollection } from './interfaces';
import { dsGetCssVarName } from '@skyeng/libs/shared/ui-kit-v2/base';

export const DefaultThemes: ThemeCollection = {
  primary: {
    base: {
      text: `var(${dsGetCssVarName(['color', 'text', 'disabled', 'base'])})`,
      background: `transparent`,
    },
    hover: {
      text: `var(${dsGetCssVarName(['color', 'icon', 'secondary', 'blue'])})`,
      background: `var(${dsGetCssVarName(['color', 'background', 'primary', 'blue'])})`,
    },
    active: {
      text: `var(${dsGetCssVarName(['color', 'icon', 'secondary', 'blue'])})`,
      background: `var(${dsGetCssVarName(['color', 'background', 'primary', 'blue'])})`,
    },
    disabled: {
      text: `var(${dsGetCssVarName(['color', 'text', 'disabled', 'base'])})`,
      background: `transparent`,
    },
  },
  'primary-tertiary': {
    base: {
      text: `var(${dsGetCssVarName(['color', 'text', 'disabled', 'base'])})`,
      background: `transparent`,
    },
    hover: {
      text: `var(${dsGetCssVarName(['color', 'text', 'tertiary', 'base'])})`,
      background: `var(${dsGetCssVarName(['color', 'background', 'primary', 'neutral'])})`,
    },
    active: {
      text: `var(${dsGetCssVarName(['color', 'icon', 'secondary', 'blue'])})`,
      background: `var(${dsGetCssVarName(['color', 'background', 'primary', 'blue'])})`,
    },
    disabled: {
      text: `var(${dsGetCssVarName(['color', 'text', 'disabled', 'base'])})`,
      background: `transparent`,
    },
  },
  'primary-blue': {
    base: {
      text: `var(${dsGetCssVarName(['color', 'icon', 'secondary', 'blue'])})`,
      background: `transparent`,
    },
    hover: {
      text: `var(${dsGetCssVarName(['color', 'icon', 'secondary', 'blue'])})`,
      background: `var(${dsGetCssVarName(['color', 'background', 'primary', 'blue'])})`,
    },
    active: {
      text: `var(${dsGetCssVarName(['color', 'icon', 'secondary', 'blue'])})`,
      background: `var(${dsGetCssVarName(['color', 'background', 'primary', 'blue'])})`,
    },
    disabled: {
      text: `var(${dsGetCssVarName(['color', 'text', 'disabled', 'base'])})`,
      background: `transparent`,
    },
  },
  'primary-outline': {
    base: {
      text: `var(${dsGetCssVarName(['color', 'text', 'disabled', 'base'])})`,
      background: `transparent`,
    },
    hover: {
      text: `var(${dsGetCssVarName(['color', 'icon', 'secondary', 'blue'])})`,
      background: `var(${dsGetCssVarName(['color', 'background', 'primary', 'blue'])})`,
    },
    active: {
      text: `var(${dsGetCssVarName(['color', 'icon', 'secondary', 'blue'])})`,
      background: `var(${dsGetCssVarName(['color', 'background', 'primary', 'blue'])})`,
    },
    disabled: {
      text: `var(${dsGetCssVarName(['color', 'text', 'disabled', 'base'])})`,
      background: `transparent`,
    },
  },
  warning: {
    base: {
      text: `var(${dsGetCssVarName(['color', 'text', 'disabled', 'base'])})`,
      background: `transparent`,
    },
    hover: {
      text: `var(${dsGetCssVarName(['color', 'icon', 'secondary', 'warning'])})`,
      background: `var(${dsGetCssVarName(['color', 'background', 'primary', 'warning'])})`,
    },
    active: {
      text: `var(${dsGetCssVarName(['color', 'icon', 'secondary', 'warning'])})`,
      background: `var(${dsGetCssVarName(['color', 'background', 'primary', 'warning'])})`,
    },
    disabled: {
      text: `var(${dsGetCssVarName(['color', 'text', 'disabled', 'base'])})`,
      background: `transparent`,
    },
  },
  dangerous: {
    base: {
      text: `var(${dsGetCssVarName(['color', 'icon', 'primary', 'red'])})`,
      background: `transparent`,
    },
    hover: {
      text: `var(${dsGetCssVarName(['color', 'icon', 'primary', 'red'])})`,
      background: `var(${dsGetCssVarName(['color', 'background', 'primary', 'red'])})`,
    },
    active: {
      text: `var(${dsGetCssVarName(['color', 'icon', 'primary', 'red'])})`,
      background: `transparent`,
    },
    disabled: {
      text: `var(${dsGetCssVarName(['color', 'text', 'disabled', 'base'])})`,
      background: `transparent`,
    },
  },
  success: {
    base: {
      text: `var(${dsGetCssVarName(['color', 'text', 'disabled', 'base'])})`,
      background: `transparent`,
    },
    hover: {
      text: `var(${dsGetCssVarName(['color', 'icon', 'secondary', 'salad'])})`,
      background: `var(${dsGetCssVarName(['color', 'background', 'primary', 'salad'])})`,
    },
    active: {
      text: `var(${dsGetCssVarName(['color', 'icon', 'secondary', 'salad'])})`,
      background: `var(${dsGetCssVarName(['color', 'background', 'primary', 'salad'])})`,
    },
    disabled: {
      text: `var(${dsGetCssVarName(['color', 'text', 'disabled', 'base'])})`,
      background: `transparent`,
    },
  },
  secondary: {
    base: {
      text: `var(${dsGetCssVarName(['color', 'icon', 'secondary', 'neutral'])})`,
      background: `transparent`,
    },
    hover: {
      text: `var(${dsGetCssVarName(['color', 'icon', 'secondary', 'blue'])})`,
      background: `var(${dsGetCssVarName(['color', 'background', 'secondary', 'blue'])})`,
    },
    active: {
      text: `var(${dsGetCssVarName(['color', 'icon', 'secondary', 'blue'])})`,
      background: `var(${dsGetCssVarName(['color', 'background', 'primary', 'blue'])})`,
    },
    disabled: {
      text: `var(${dsGetCssVarName(['color', 'icon', 'secondary', 'neutral'])})`,
      background: `transparent`,
    },
  },
  'primary-neutral': {
    base: {
      text: `var(${dsGetCssVarName(['color', 'icon', 'primary', 'neutral'])})`,
      background: `transparent`,
    },
    hover: {
      text: `var(${dsGetCssVarName(['color', 'icon', 'primary', 'neutral'])})`,
      background: `var(${dsGetCssVarName(['color', 'background', 'primary', 'neutral'])})`,
    },
    active: {
      text: `var(${dsGetCssVarName(['color', 'icon', 'primary', 'neutral'])})`,
      background: `var(${dsGetCssVarName(['color', 'background', 'primary', 'neutral'])})`,
    },
    disabled: {
      text: `var(${dsGetCssVarName(['color', 'icon', 'primary', 'neutral'])})`,
      background: `transparent`,
    },
  },
  'primary-disabled': {
    base: {
      text: `var(${dsGetCssVarName(['color', 'text', 'disabled', 'base'])})`,
      background: `var(${dsGetCssVarName(['color', 'background', 'primary', 'neutral'])})`,
    },
    hover: {
      text: `var(${dsGetCssVarName(['color', 'icon', 'secondary', 'blue'])})`,
      background: `var(${dsGetCssVarName(['color', 'background', 'primary', 'blue'])})`,
    },
    active: {
      text: `var(${dsGetCssVarName(['color', 'icon', 'secondary', 'blue'])})`,
      background: `var(${dsGetCssVarName(['color', 'background', 'primary', 'blue'])})`,
    },
    disabled: {
      text: `var(${dsGetCssVarName(['color', 'text', 'disabled', 'base'])})`,
      background: `var(${dsGetCssVarName(['color', 'background', 'primary', 'neutral'])})`,
    },
  },
  'primary-white': {
    base: {
      text: `var(${dsGetCssVarName(['color', 'icon', 'primary', 'neutral'])})`,
      background: `transparent`,
    },
    hover: {
      text: `var(${dsGetCssVarName(['color', 'icon', 'primary', 'neutral'])})`,
      background: `var(${dsGetCssVarName(['color', 'text', 'primary', 'inverted'])})`,
    },
    active: {
      text: `var(${dsGetCssVarName(['color', 'icon', 'primary', 'neutral'])})`,
      background: `var(${dsGetCssVarName(['color', 'text', 'primary', 'inverted'])})`,
    },
    disabled: {
      text: `var(${dsGetCssVarName(['color', 'icon', 'primary', 'neutral'])})`,
      background: `transparent`,
    },
  },
  'primary-inverted': {
    base: {
      text: `var(${dsGetCssVarName(['color', 'text', 'disabled', 'inverted'])})`,
      background: `transparent`,
    },
    hover: {
      text: `var(${dsGetCssVarName(['color', 'text', 'link', 'inverted'])})`,
      background: `transparent`,
    },
    active: {
      text: `var(${dsGetCssVarName(['color', 'text', 'link', 'inverted'])})`,
      background: `transparent`,
    },
    disabled: {
      text: `var(${dsGetCssVarName(['color', 'text', 'disabled', 'base'])})`,
      background: `transparent`,
    },
  },
};
